<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">

          <a-col :span="6">
            <mtc-form-item label="label.head">
              <a-input :placeholder="$t('label.pleaseEnterHead')" v-model="queryParam.titile"></a-input>
            </mtc-form-item>
          </a-col>
          <!--<a-col :span="6">
            <a-form-item label="内容">
              <a-input placeholder="请输入内容" v-model="queryParam.msgContent"></a-input>
            </a-form-item>
          </a-col>-->

          <a-col :span="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <!--<a-button type="primary" @click="searchQuery" icon="search">{{$t('button.search')}}</a-button>-->
              <!--<a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{$t('button.reset')}}</a-button>-->
              <mtc-button @click="searchQuery" type="primary" icon="search"  text="button.search"></mtc-button>
              <mtc-button @click="searchReset" type="primary" icon="reload"  style="margin-left: 8px" text="button.reset"></mtc-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!--<a-button @click="handleAdd" type="primary" icon="plus">{{$t('button.add')}}</a-button>-->
      <mtc-button @click="handleAdd" type="primary" icon="plus"  text="button.add"></mtc-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('系统通告')">{{$t('button.export')}}</a-button>-->
      <mtc-button @click="handleExportXls('多语言国际化')" type="primary" icon="download"  text="button.export"></mtc-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <!--<a-button type="primary" icon="import">{{$t('button.import')}}</a-button>-->
        <mtc-button type="primary" icon="import"  text="button.import"></mtc-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel">
            <a-icon type="delete"/>
            {{$t('button.delete')}}
          </a-menu-item>
        </a-menu>
        <mtc-button style="margin-left: 8px" text="button.batchOperation">
          <a-icon type="down"/>
        </mtc-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{$t('tip.selected')}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{$t('tip.term')}}
        <a style="margin-left: 24px" @click="onClearSelected">{{$t('button.clear')}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template v-for="(item, index) in columns" :slot="item.slotName">
          <!--<span :key="index">{{ $t(item.slotName) }}</span>-->
          <mtcHeader :key="index" :text="item.slotName" />
        </template>

        <span slot="action" slot-scope="text, record">
          <!--<a  v-if="record.sendStatus == 0" @click="handleEdit(record)">{{$t('button.edit')}}</a>-->
          <mtc-button v-if="record.sendStatus == 0" @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" v-if="record.sendStatus == 0"/>
          <a-dropdown>
            <!--<a class="ant-dropdown-link">{{$t('button.more')}} <a-icon type="down"/></a>-->
            <mtc-button  class="ant-dropdown-link" type="link" size="small" text="button.more"></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.sendStatus != 1">
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{$t('button.delete')}}</a>-->
                  <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.sendStatus == 0">
                <a-popconfirm :title="$t('tip.queDingFaBuMa')" @confirm="() => releaseData(record.id)">
                  <!--<a>发布</a>-->
                  <mtc-button type="link" size="small" text="button.release"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.sendStatus == 1">
                <a-popconfirm :title="$t('tip.queDingCheXiaoMa')" @confirm="() => reovkeData(record.id)">
                  <!--<a>撤销</a>-->
                   <mtc-button type="link" size="small" text="button.revoke"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <!--<a @click="handleDetail(record)">查看</a>-->
                <mtc-button @click="handleDetail(record)" type="link" size="small" text="button.see"></mtc-button>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysAnnouncement-modal ref="modalForm" @ok="modalFormOk"></sysAnnouncement-modal>
  </a-card>
</template>

<script>
  import SysAnnouncementModal from './modules/SysAnnouncementModal'
  import {doReleaseData, doReovkeData} from '@/api/api'
  import {getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { MTC_AUTH } from '@api/servers'

  export default {
    name: "SysAnnouncementList",
    mixins: [JeecgListMixin],
    components: {
      SysAnnouncementModal
    },
    data() {
      return {
        description: '系统通告表管理页面',
        // 查询条件
        queryParam: {},
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: function (t, r, index) {
              return parseInt(index) + 1;
            }
          },

          {
            slotName: 'label.head',
            // title: '标题',
            align: "center",
            dataIndex: 'titile',
            scopedSlots: { title: 'label.head'}

          },
          {
            slotName: 'label.messageType',
            // title: '消息类型',
            align: "center",
            dataIndex: 'msgCategory',
            customRender: function (text) {
              if (text == '1') {
                return "通知公告";
              } else if (text == "2") {
                return "系统消息";
              } else {
                return text;
              }
            },
            scopedSlots: { title: 'label.messageType'}
          },
          /*{
            title: '开始时间',
            align: "center",
            dataIndex: 'startTime'
          },
          {
            title: '结束时间',
            align: "center",
            dataIndex: 'endTime'
          },*/
          {
            slotName: 'label.publisher',
            // title: '发布人',
            align: "center",
            dataIndex: 'sender',
            scopedSlots: { title: 'label.publisher'}
          },
          {
            slotName: 'label.priority',
            // title: '优先级',
            align: "center",
            dataIndex: 'priority',
            customRender: function (text) {
              if (text == 'L') {
                return "低";
              } else if (text == "M") {
                return "中";
              } else if (text == "H") {
                return "高";
              } else {
                return text;
              }
            },
            scopedSlots: { title: 'label.priority'}
          },
          {
            slotName: 'label.notificationObject',
            // title: '通告对象',
            align: "center",
            dataIndex: 'msgType',
            customRender: function (text) {
              if (text == 'USER') {
                return "指定用户";
              } else if (text == "ALL") {
                return "全体用户";
              } else {
                return text;
              }
            },
            scopedSlots: { title: 'label.notificationObject'}
          },
          {
            slotName: 'label.releaseStatus',
            // title: '发布状态',
            align: "center",
            dataIndex: 'sendStatus',
            customRender: function (text) {
              if (text == 0) {
                return "未发布";
              } else if (text == 1) {
                return "已发布";
              } else if (text == 2) {
                return "已撤销";
              } else {
                return text;
              }
            },
            scopedSlots: { title: 'label.releaseStatus'}
          },
          {
            slotName: 'label.releaseTime',
            // title: '发布时间',
            align: "center",
            dataIndex: 'sendTime',
            scopedSlots: { title: 'label.releaseTime'}
          },
          {
            slotName: 'label.cancellationTime',
            // title: '撤销时间',
            align: "center",
            dataIndex: 'cancelTime',
            scopedSlots: { title: 'label.cancellationTime'}
          },
          /*{
                title: '删除状态（0，正常，1已删除）',
                align:"center",
                dataIndex: 'delFlag'
              },*/
          {
            slotName: 'tableHeader.operation',
            // title: '操作',
            dataIndex: 'action',
            scopedSlots: {customRender: 'action', title: 'tableHeader.operation'},
            align: "center",
            width: 170
          }
        ],
        url: {
          list: `${MTC_AUTH}sys/annountCement/list`,
          delete: `${MTC_AUTH}sys/annountCement/delete`,
          deleteBatch: `${MTC_AUTH}sys/annountCement/deleteBatch`,
          releaseDataUrl: `${MTC_AUTH}sys/annountCement/doReleaseData`,
          reovkeDataUrl: `${MTC_AUTH}sys/annountCement/doReovkeData`,
          exportXlsUrl: `${MTC_AUTH}sys/annountCement/exportXls`,
          importExcelUrl: `${MTC_AUTH}sys/annountCement/importExcel`,
        },
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      //执行发布操作
      releaseData: function (id) {
        console.log(id);
        var that = this;
        doReleaseData({id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      //执行撤销操作
      reovkeData: function (id) {
        var that = this;
        doReovkeData({id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
            this.syncHeadNotic(id)
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      syncHeadNotic(anntId){
        getAction("sys/annountCement/syncNotic",{anntId:anntId})
      },
      handleDetail:function(record){
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title="详情";
        this.$refs.modalForm.disableSubmit = true;
        this.$refs.modalForm.disabled = true;
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less'
</style>